import axios from 'axios'
import Cookies from 'js-cookie'

const API_DOMAIN = process.env.REACT_APP_API_DOMAIN
const BACKOFFICE_DOMAIN = process.env.REACT_APP_BACKOFFICE_API_DOMAIN
const API_ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY // chave fixa para o backend API

function isApiUrl(url) {
  return typeof url === 'string' && API_DOMAIN && url.startsWith(API_DOMAIN)
}

function isBackofficeUrl(url) {
  return typeof url === 'string' && BACKOFFICE_DOMAIN && url.startsWith(BACKOFFICE_DOMAIN)
}

const axiosInstance = axios.create()

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {}
    config.headers['Accept'] = 'application/json'

    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData
    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json'
    } else {
      delete config.headers['Content-Type']
    }

    if (isApiUrl(config.url)) {
      // API normal -> usa X-API-Key
      delete config.headers['Authorization']
      config.headers['X-API-Key'] = API_ACCESS_KEY
    } else if (isBackofficeUrl(config.url)) {
      // Backoffice -> usa access token
      const token = localStorage.getItem('access-token')
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      } else {
        delete config.headers['Authorization']
      }
    } else {
      // Outros casos
      delete config.headers['Authorization']
      delete config.headers['X-API-Key']
    }

    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    // DEV BYPASS: Se REACT_APP_DEV_BYPASS=true, não redireciona para login
    const devBypass = process.env.REACT_APP_DEV_BYPASS === 'true'
    if (devBypass) {
      console.warn('[DEV] Axios interceptor bypass - error ignored')
      return Promise.reject(error)
    }

    if (
      isBackofficeUrl(originalRequest?.url) &&
      error?.response?.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true
      const refreshToken = Cookies.get('refresh-token')

      if (!refreshToken) {
        window.location.href = '/login'
        return Promise.reject(error)
      }

      try {
        // Renova o access token usando o refresh token
        const resp = await axios.put(
          `${BACKOFFICE_DOMAIN}/api/v1/session`,
          {},
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${refreshToken}` // PUT usa refresh token
            }
          }
        )

        const newAccessToken = resp?.data?.payload?.access
        if (newAccessToken) {
          localStorage.setItem('access-token', newAccessToken)
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`
          return axiosInstance(originalRequest)
        } else {
          Cookies.remove('refresh-token')
          window.location.href = '/login'
          return Promise.reject(error)
        }
      } catch (refreshError) {
        Cookies.remove('refresh-token')
        window.location.href = '/login'
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
